import { Input, Output, Component, ViewChild, ElementRef, OnInit, OnDestroy, EventEmitter, OnChanges } from '@angular/core';
import { generaleMethodes } from '../generaleMethodes.component';
import { SearchCriteria } from '../../utils/searchCriteria';
import { Modules, UserRole } from '../../utils/enumeration';
import { ExportService } from '../../services/export.service';
import { UploadComponent } from '../../utils/uploadComponent';
import { UploadOutput, UploadFile, UploadInput } from 'ngx-uploader';
import { setTimeout } from 'timers';
import { DomSanitizer } from '@angular/platform-browser';
import { Statique } from '../../utils/statique';
import { ModalService } from '../modal/modal.service';
import { SearchCriteriaPricingBooking } from '../../utils/SearchCriteriaPricingBooking';
import { DataTableConfig } from '../../utils/dataTableConfig';
import { DataTableDirective } from 'angular-datatables';
import { RequestProcessing } from '../../utils/requestProcessing';
import { CompleterData, CompleterService } from 'ng2-completer';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-collapsible-panel',
	templateUrl: './collapsible-panel.component.html',
	styleUrls: ['./collapsible-panel.component.css']
})
export class CollapsiblePanelComponent extends UploadComponent implements OnInit, OnDestroy {
	@Input() dtElement?: DataTableDirective;
	@Input() title: string;
	@Input() collapse?: string;
	@Input() fullscreen?: boolean;
	@Input() csvExtractModule?: number;
	@Input() csvExtractPeriode?: boolean;
	@Input() searchInput?: SearchCriteriaPricingBooking;
	@Input() dataUpload?: any;

	@Output() onDataUploadClick = new EventEmitter<Function>();
	@Output() onUploadCompleteHandler = new EventEmitter<UploadFile>();
	@Output() onUploadProgressHandler = new EventEmitter<UploadFile>();

	@Input() panelClass?: string;
	@Input() headingClass?: string;
	@Input() bodyClass?: string;

	@ViewChild('panel') panelEl: ElementRef;
	@ViewChild('fileInput') fileInput: ElementRef;

	UserRole = UserRole;
	Modules = Modules;
	startUploading: number;
	outputFile: UploadOutput;

	idSearchDtInterval: number = null;
	isSearchDtDestroyed: boolean = false;
	isSearchDtBusy: boolean = true;


	suggestionsDfr: CompleterData;
	@Output() searchHandler = new EventEmitter<any>();
	searchDfr: string = ''
	protected subscribedSelectedSf: Subscription;

	constructor(
		private generaleMethode: generaleMethodes,
		private exportService: ExportService,
		protected sanitizer: DomSanitizer,
		private modalService: ModalService,
		private completerService: CompleterService

	) {
		super(sanitizer);

		this.componentObject = this;
		this.isGallery = null;


	}

	ngOnInit() {
		// var autocompleteUrlOrigin = `/listDfr`;
		// let autocompleteUrlDfr="/listDfr";
		// autocompleteUrlDfr +=
		//    autocompleteUrlOrigin.indexOf("?") > 0 ? "&" : "?";
		//    autocompleteUrlDfr += `term=`;
		// this.suggestionsDfr = this.completerService.remote(
		// 	Statique.controllerPricing + autocompleteUrlDfr
		//   );

		if (typeof this.collapse === "undefined")
			this.collapse = null;
		if (typeof this.fullscreen === "undefined")
			this.fullscreen = true;
		if (typeof this.csvExtractModule === "undefined")
			this.csvExtractModule = null;
		if (typeof this.dataUpload === "undefined")
			this.dataUpload = null;

		if (typeof this.panelClass === "undefined")
			this.panelClass = "panel-table";
		if (typeof this.headingClass === "undefined")
			this.headingClass = "heading-table";
		if (typeof this.bodyClass === "undefined")
			this.bodyClass = "body-table";

		this.moveDatatableFilter();
		this.rerenderDatatableFilter();
	}

	panelCollapse(panel, event) {
		this.generaleMethode.panelCollapse(panel, event);
	}

	panelFullScreen(panel) {
		this.generaleMethode.panelFullScreen(panel);
	}

	getSearchInput(): boolean {

		if (this.dtElement && this.dtElement["dt"] && this.dtElement["dt"].search() != '') {

			return true;

		}
		return false;
	}


	exportCsv(event: any, exp: number) {
		let requestProcessing = new RequestProcessing();
		requestProcessing.beforeSendRequest(event);

		if (!this.searchInput) {
			this.searchInput = new SearchCriteriaPricingBooking();
		}
		if (this.dtElement) {
			// if(exp==2)
			this.searchInput.searchterm = this.dtElement["dt"].search();
			// else if(exp==1)
			// 	this.searchInput.numAwbBol= this.dtElement["dt"].search();
		}

		this.exportService.exportCsvFile(this.csvExtractModule, this.csvExtractPeriode, this.searchInput, exp);

		setTimeout(() => {
			requestProcessing.afterGetResponse(event);
		}, 2000);


		//this.exportService.exportCsvFile(this.csvExtractModule, this.csvExtractPeriode, this.searchInput);
	}

	fileInputHandle() {
		this.startUploading = 0;
		this.fileInput.nativeElement.value = null;
		this.outputFile = null;

		this.fileInput.nativeElement.click();

		this.onDataUploadClick.emit(function () {
			this.startUploading++;
			if (this.startUploading >= 2) {
				setTimeout(function () {
					this.startUpload();
				}.bind(this), 500);
			}
		}.bind(this));
	}

	uploadFile(output: UploadOutput) {
		this.onUploadOutput(output);
		this.startUploading++;
		if (this.startUploading >= 2) {
			setTimeout(function () {
				this.startUpload();
			}.bind(this), 500);
		}
	}

	rerenderDatatableFilter() {
		this.idSearchDtInterval = setInterval(async function () {
			try {

				if (!this.isSearchDtBusy && !this.isSearchDtDestroyed) {
					this.isSearchDtBusy = true;

					let collapsContainer = this.panelEl.nativeElement;
					let allFilters = collapsContainer.getElementsByClassName("dataTables_filter");
					let filterEl = collapsContainer.querySelectorAll(".panel-controls .datatable-search .dataTables_filter")[0];
					if (allFilters.length > 1 && filterEl) {
						filterEl.remove();
						await this.moveDatatableFilter();
					}
					this.isSearchDtBusy = false;
				}
			}
			catch (e) { }

			if (this.isSearchDtDestroyed && this.idSearchDtInterval) {
				clearInterval(this.idSearchDtInterval);
			}
		}.bind(this), 400);
	}

	async moveDatatableFilter() {
		this.isSearchDtBusy = true;

		try {
			let filterEl;
			let tmpEl;
			let collapsContainer = this.panelEl.nativeElement;

			let timer = 0;
			while (!(filterEl = collapsContainer.getElementsByClassName("dataTables_filter")[0]) && timer < 10000) {
				await Statique.waitForTimemout(400);
				timer += 400;
			}

			tmpEl = collapsContainer ? (tmpEl = collapsContainer.getElementsByClassName("datatable-search")) ? tmpEl[0] : null : null;
			if (tmpEl && filterEl) {
				Statique.moveDomElement(filterEl, tmpEl);
				filterEl.className += " d-inline-block";
				filterEl = filterEl.getElementsByTagName("label");
				filterEl = (filterEl = collapsContainer.getElementsByClassName("dt-buttons")) ? filterEl[0] : null;
				tmpEl = collapsContainer ? (tmpEl = collapsContainer.getElementsByClassName("datatable-filter")) ? tmpEl[0] : null : null;
				if (filterEl && tmpEl) {
					Statique.moveDomElement(filterEl, tmpEl);
				}
			}
		} catch (e) { }

		this.isSearchDtBusy = false;
	}
	// fonction positionnement du filter des colonnes (dataTable)
	moveDatatableColumnsFilter() {

		let datatableColumnsFilter = <HTMLElement>document.querySelector('.dt-button-collection');
		let datatableColumnsBackground = <HTMLElement>document.querySelector('.dt-button-background');
		let btnPosition = document.querySelector('.datatable-filter.d-inline-block').getBoundingClientRect();

		datatableColumnsBackground.appendChild(datatableColumnsFilter);
		datatableColumnsFilter.style.top = btnPosition.top + 15 + "px";

	}

	onUploadComplete(file: UploadFile) {
		this.onUploadCompleteHandler.emit(file);
	}

	ngOnDestroy() {
		// if(this.subscribedSelectedSf)
		// 	this.subscribedSelectedSf.unsubscribe();

		if (this.idSearchDtInterval)
			clearInterval(this.idSearchDtInterval);
		this.idSearchDtInterval = null;
		this.isSearchDtDestroyed = true;

		let filterEl;
		if (filterEl = this.panelEl.nativeElement.getElementsByClassName("dataTables_filter")[0])
			filterEl.parentNode.removeChild(filterEl);
	}

	onUploadProgress(file: UploadFile) {
		this.onUploadProgressHandler.emit(file);
	}

	search() {
		//if(this.listSelectedFields && this.listSelectedFields.length > 0){
		let result = {}, value = null;



		result['numAwbBol'] = this.searchDfr;
		this.searchHandler.emit(result);
		//}
	}


}



// WEBPACK FOOTER //
// ./src/app/shared/collapsible-panel/collapsible-panel.component.ts